import Vue from "vue";
import VueI18n from "vue-i18n";

Vue.use(VueI18n);
import ptBr from "./pt-br";

const i18n = new VueI18n({
  locale: "pt-br",
  messages: {
    "pt-br": ptBr,
  },
});

export default i18n;
